var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-navi-side-menu-footer-block" }, [
    _c("div", { staticClass: "global-navi-declaration" }, [
      _c("a", { attrs: { href: _vm.declarationLink } }, [
        _c("div", { staticClass: "global-navi-declaration-img-icon" }),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "global-navi-micael" }, [
      _c("a", { attrs: { href: _vm.micaelLink } }, [
        _c("div", { staticClass: "global-navi-micael-img-icon" }),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "global-navi-declaration-target" }, [
      _c("p", { staticClass: "global-navi-at-cosme" }, [_vm._v("@cosme宣言")]),
      _vm._v(" "),
      _c("p", { staticClass: "global-navi-safety" }, [
        _vm._v("安心してご利用いただけるサイト運営を目指して"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "global-navi-micael-target" }, [
      _c("p", { staticClass: "global-navi-micael-title" }, [
        _vm._v("@cosmeのミカエルって？"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }